// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const HelpIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.8 22.5 12 17.8 1.5 12 1.5"
        opacity=".5"
      />
      <path d="m13.89 12.88-.16.09c-.71.4-.97.6-.96.95 0 .46-.36.84-.82.84s-.83-.36-.84-.81c-.02-1.4 1.13-2.05 1.81-2.43l.16-.09q.94-.51.94-1.43c0-1-.81-1.8-1.8-1.8-1.02 0-1.82.79-1.82 1.8 0 .46-.37.83-.83.83s-.83-.37-.83-.83c0-1.9 1.56-3.46 3.47-3.46s3.47 1.55 3.47 3.46c0 1.22-.64 2.24-1.8 2.88m-1.95 4.6c-.46 0-.83-.35-.83-.8v-.04c0-.46.37-.83.83-.83s.83.37.83.83-.37.84-.83.84" />
    </g>
  </SvgIcon>
);

export default HelpIcon;
